import { render, staticRenderFns } from "./MerchantOrders.vue?vue&type=template&id=6584d9df&scoped=true"
import script from "./MerchantOrders.vue?vue&type=script&lang=js"
export * from "./MerchantOrders.vue?vue&type=script&lang=js"
import style0 from "./MerchantOrders.vue?vue&type=style&index=0&id=6584d9df&prod&scoped=true&lang=css"
import style1 from "./MerchantOrders.vue?vue&type=style&index=1&id=6584d9df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584d9df",
  null
  
)

export default component.exports